import styled from "styled-components";

export const Wrapper = styled.div`
  background: transparent;
  font-family: "Open Sans", sans-serif;
  width: 100%;
`;
